import React from 'react';
import PropTypes from "prop-types";
import Spinner from "../../../qwc2/components/widgets/Spinner";
import LocaleUtils from "../../../qwc2/utils/LocaleUtils";
import AbstractTab from "./AbstractTab";
import {connect} from "react-redux";
import {addDetailWindow, setDetailWindow} from "../../actions/details";
import ComponentUtils from "../../utils/ComponentUtils";

class ComponentAddTab extends AbstractTab {

    static propTypes = {
        addDetailWindow: PropTypes.func,
        addTab: PropTypes.func,
        feature: PropTypes.object,
        labelUpdate: PropTypes.func,
        setDetailWindow: PropTypes.func,
        tab: PropTypes.object,
        windowId: PropTypes.string,
        windowType: PropTypes.string
    }

    static defaultProps = {
        feature: {},
        tab: {},
        windowId: ''
    }

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            search: "",
            isLoading: true
        };
    }

    componentDidMount() {
        const self = this;
        ComponentUtils.getAddComponents(response => {
            self.setState({
                data: response.data,
                isLoading: false
            });
        });
    }

    search(value) {
        this.setState({search: value});
    }

    selectType(type, subType) {
        console.log('Add component to', this.props.feature, subType);
        const properties = {
            name: '',
            guid: '',
            label: '',
            number: ''
        };
        if (subType) {
            const subTypeId = this.getSubtypePropertyId();
            properties[subTypeId] = subType.value;
        }
        if (this.props.feature.addComponentTo == 'component') {
            properties.belongsToGuid = this.props.feature.belongsTo.properties.belongsToGuid;
            properties.parentComponentGuid  = this.props.feature.belongsTo.properties.id;
        } else {
            //const refProperty = this.props.feature.belongsTo.properties.objectType;
            const refId = this.props.feature.belongsTo.properties.id;
            //properties[refProperty] = refId;
            properties.belongsToGuid = refId;
        }
        const tab = ComponentUtils.getFormTab({
            properties: {},
            attributes: type.properties
        }, {
            type: type.guid,
            geometry: {
                type: 'Point',
                coordinates: this.props.feature.clickPoint
            },
            properties: properties
        }, ComponentUtils.getAddUrl(type.guid), 'post');
        tab.label = type.identifier + ' ' + type.nameDe;
        this.props.addTab('addcomponent', tab);
    }

    getSubtypePropertyId = () => {
        return '8fae9337-290c-47bc-b205-9e6370007e6d';
    }

    getSubTypes = (type) => {
        const code = this.getSubtypePropertyId();
        if (type.properties && type.properties.length) {
            let found = null;
            type.properties.forEach(property => {
                if (code == property.propertyCode) {
                    found = property.enumeratorValues;
                }
            });
            if (found) {
                return found;
            }
        }
        return [];
    }


    renderResults() {
        if (this.state.data && this.state.data.classes && this.state.search) {
            const valid = [];
            this.state.data.classes.forEach(type => {
                if (!(type.properties) || type.properties.length === 0) {
                    return;
                }
                if (valid.length > 15) {
                    return;
                }
                const nameMatch = type.nameDe && type.nameDe.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1;
                const identMatch = type.identifier && type.identifier.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1;
                if (nameMatch || identMatch) {
                    valid.push({name: type.identifier + ' - ' + type.nameDe, type: type});
                }
                const subTypes = this.getSubTypes(type);
                subTypes.forEach(subType => {
                    if (valid.length > 15) {
                        return;
                    }
                    const subTypeMatch = subType.text && subType.text.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1;
                    if (nameMatch || identMatch || subTypeMatch) {
                        valid.push({name: type.identifier + ' - ' + type.nameDe + ' - ' + subType.text, type: type, subType: subType});
                    }
                })
            });
            return (
                <ul>
                    {valid.map((validOption, i) => {
                        return (
                            <li key={i} onClick={() => this.selectType(validOption.type, validOption.subType)}>{validOption.name}</li>
                        );
                    })}
                </ul>
            );
        }
        return null;
    }


    render() {
        //console.log('Belto', this.props.feature.belongsTo);
        return (
            <div className="feature-details-component-add">
                {this.state.isLoading &&
                    <div>
                        <Spinner/>
                        <div>{LocaleUtils.tr("attribtable.loading")}</div>
                    </div>
                }
                {!this.state.isLoading &&
                    <div>
                        <input onChange={ev => this.search(ev.target.value)} placeholder="Suchtext eingeben ..."
                               type="text" value={this.state.search}/>
                        {this.renderResults()}
                    </div>
                }
            </div>
        );
    }

    renderData() {
        return JSON.stringify(this.state.data);
    }
}

const selector = () => ({});

export default connect(selector, {
    setDetailWindow: setDetailWindow,
    addDetailWindow: addDetailWindow,
})(ComponentAddTab);
